import { Injectable } from "@angular/core";
// import { Observable } from 'rxjs';
import WalletConnect from "@walletconnect/client";
import IWalletConnectOptions from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { async, BehaviorSubject } from "rxjs";
const BN = require("bn.js");
import * as listener from "../../scripts/listener.js";
import { ethers } from "ethers";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "./api.service";
// import WalletConnectProvider from "@walletconnect/web3-provider";

// let web3 = new Web3('https://cronos-testnet-3.crypto.org:8545');
// import Web3 from "web3"
// var Contract = require('web3-eth-contract');
declare let window: any;

@Injectable({
  providedIn: "root",
})
export class WalletService {
  metamaskInstalled = false;
  public crowdsaleData = new BehaviorSubject<any>(null);
  private crowdsale: any;
  address = "";
  private connector: WalletConnect;
  private connectorOpts: IWalletConnectOptions;

  constructor(private _aS: ApiService) {
    this.connector = new WalletConnect({
      bridge: "https://bridge.walletconnect.org", // Required
      qrcodeModal: QRCodeModal,
    });
  }
  async addNewToken(
    tokenAddress: string,
    tokenSymbol: string,
    tokenDecimals: number,
    tokenImage: string
  ) {
    await window.ethereum
      .request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            image: tokenImage,
          },
        },
      })
      .then((success) => {
        if (success) {
          console.log("Successfully added to wallet!");
        } else {
          throw new Error("something went wrong.");
        }
      })
      .catch(console.error);
  }

  checkMetmaskInstalled() {
    if (window.ethereum === undefined) {
      this.metamaskInstalled = false;
    } else {
      this.metamaskInstalled = true;
    }
    return this.metamaskInstalled;
  }
  // Init for metamask
  initConnection() {
    if (window.ethereum !== undefined) {
      if (!this.checkWalletConnection()) {
        return true;
      } else {
        return this.loadMetamask();
      }
    } else {
      return false;
    }
  }
  // Get Metamask address
  getAddress = async () => {
    if (window.ethereum !== undefined) {
      let addr = await window.ethereum.request({
        method: "eth_accounts",
      });
      return addr[0];
    } else {
      return undefined;
    }
  };

  // Get CryptoCom address (Should work for other wallets too.)
  getCryptoComAddress = async () => {
    // return await this.connector.accounts;
    if (this.connector.connected) {
      return this.connector.accounts;
    }
  };

  //Check If Metamask wallet is disconnected
  checkWalletDisconnect = async () => {
    if (window.ethereum !== undefined) {
      window.ethereum.on("accountsChanged", async () => {
        location.reload();
      });
    }
  };

  // Check if Metamask Wallet is connected
  checkWalletConnection = async () => {
    if (window.ethereum !== undefined) {
      let ethAcc = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (ethAcc.length !== 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // Load Metamask account and set it to this.address
  loadMetamask = async () => {
    if (window.ethereum !== undefined) {
      let accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      window.location.reload();
      this.address = accounts[0];
      return accounts[0];
    }
  };
  logout = async () => {};

  // Create connection for wallet connect
  createConnectionWalletConnect = async () => {
    // // Check if connection is already established
    if (!this.connector.connected) {
      // create new session
      // this.connector.createSession();
      await this.connector.connect();
      window.location.reload();
    } else {
      return this.connector.accounts;
    }

    // Subscribe to connection events
    this.connector.on("connect", (error, payload) => {
      if (error) {
        throw error;
      }

      // Get provided accounts and chainId
      const { accounts, chainId } = payload.params[0];
      this.address = accounts;
      console.log(this.address);
      // console.log(accounts);
    });

    this.connector.on("session_update", (error, payload) => {
      if (error) {
        throw error;
      }

      // Get updated accounts and chainId
      const { accounts, chainId } = payload.params[0];
      this.address = accounts;
      console.log(this.address);
    });

    this.connector.on("disconnect", (error, payload) => {
      if (error) {
        throw error;
      }

      // Delete connector
    });
  };

  // KIll wallet connect session (Disconnect wallet)
  destroyConnectionWalletConnect() {
    if (this.connector.connected) {
      this.connector.killSession();
      window.location.reload();
    }
  }

  signTransactionsWalletConnect(currentUserAddress) {
    const tx = {
      from: currentUserAddress,
      // to: "0x8f9bfd0aada01393d04b06b1cf58863963a25bed", // Contract address TBA
      to: currentUserAddress,
      data: "0x",
    };
    this.connector
      .sendTransaction(tx)
      .then((result) => {
        // Returns signed transaction
        console.log(result);
      })
      .catch((error) => {
        // Error returned when rejected
        console.error(error);
      });
  }
  signTransactionsMetamask = async (currentUserAddres, value) => {
    let txHash = "";
    let contributionValue = value * 1000000000000000000;
    let contributionAmount = contributionValue.toString(16);
    let params = [
      {
        from: currentUserAddres,
        to: currentUserAddres,
        gas: "0x76c0", // 30400
        gasPrice: "0x9184e72a000", // 10000000000000
        // value: "0xDE0B6B3A7640000", // VALUE FOR 1
        value: contributionAmount,
      },
    ];
    await window.ethereum
      .request({
        method: "eth_sendTransaction",
        params,
      })
      .then((result) => {
        txHash = result;
      })
      .catch((error) => {
        console.error(error);
      });
    return txHash;
  };
  sendTransactionWalletConnect = async (
    currentUserAddress: string,
    contributionAmount
  ) => {
    this.createConnectionWalletConnect();
    let contractAddressBeyondi = "0xDaEF18D51c2db5F300709CB6A97191878Dc1720f";
    // let contractAddressUsdcMain = "0xc21223249CA28397B4B6541dfFaEcC539BfF0c59";
    let contractInstance = await listener.getContractInstance(
      contractAddressBeyondi
    );

    let addressHolder = "0x33C387551E5Ca235B06c59093209ac32aFa9Ef07"; // This is Beyondi test wallet
    let bnFormatedNumber =
      "0x" + (await listener.getFormatedNumber(contributionAmount));
    if (Array.isArray(currentUserAddress)) {
      currentUserAddress = currentUserAddress[0].toLowerCase();
    }
    let txHash = "";
    const tx = {
      method: "eth_sendTransaction",

      // params: [{
      // gasPrice: '0x09184e72a000', // customizable by user during MetaMask confirmation.
      //  gasPrice: "0x5925091C250", // Metamask ignores gas price - but without gasPrice set it fails
      // gas: '0x39100', // Metamask ignores gas - but without gas set it fails
      // gasPrice: "0x1388", // Metamask ignores gas price - but without gasPrice set it fails
      // gasLimit: '0x2388', // Metamask ignores gas - but without gas set it fails
      gasPrice: "0x5925091C250", // Metamask ignores gas price - but without gasPrice set it fails
      gas: "0x39100", // Metamask ignores gas - but without gas set it fails
      from: currentUserAddress,
      to: contractAddressBeyondi,
      data: await contractInstance.methods
        .transfer(addressHolder, bnFormatedNumber)
        .encodeABI(),

      // }]
      // from: currentUserAddress,
      // to: contractAddressLitBit,
      // // gasPrice: "0x4A817C800",
      // // gasLimit: "0x9c40", // Optional
      // gasPrice: "0x5925091C250", // Metamask ignores gas price - but without gasPrice set it fails
      // gas: '0x39100', // Metamask ignores gas - but without gas set it fails

      // data: await contractInstance.methods.transfer(addressHolder, bnFormatedNumber).encodeABI(),
    };
    // let txHash = await listener.sendTransactionWalletConnection(tx);
    // // Send transaction
    await this.connector
      .sendTransaction(tx)
      .then((result) => {
        txHash = result;
        return result;
      })
      .catch((error) => {
        console.error(error);
      });
    return txHash;
  };
  releaseTokensMetamask = async (userToRelease, activeStage) => {
    activeStage += 1; // reason for this is temp, we need a new column in table which states (ActiveTier on blockchain)
    const beyondiWalletAddress = "0x33C387551E5Ca235B06c59093209ac32aFa9Ef07";
    const contractAddressBYND = "0xDaEF18D51c2db5F300709CB6A97191878Dc1720f";

    const crowdsaleContractAddress =
      "0x7BE68BD6017b9d5390FeEc513D6E9B8aADeb3FD9";

    const purchaser = userToRelease;
    let contractInstance = await listener.getContractInstance(
      contractAddressBYND
    );

    let crowdsaleContractInstance = await listener.getCrowdsaleContractInstance(
      crowdsaleContractAddress
    );
    let txHash = "";
    let addressHolder = "0x33C387551E5Ca235B06c59093209ac32aFa9Ef07"; // This is Beyondis test wallet
    let userContribAmount = await crowdsaleContractInstance.methods
      .getContributedAmountPerUserPerStage(purchaser, 0)
      .call();
    let bnFormatedNumber =
      "0x" + (await listener.getFormatedNumber(userContribAmount));

    console.dir(userContribAmount);
    // APPROVAL FUNCTION
    await window.ethereum
      .request({
        method: "eth_sendTransaction",
        params: [
          {
            gas: "0x39100", // Metamask ignores gas - but without gas set it fails
            from: beyondiWalletAddress,
            to: contractAddressBYND,
            data: await contractInstance.methods
              .approve(crowdsaleContractAddress, bnFormatedNumber)
              .encodeABI(),
          },
        ],
      })
      .then((result) => {
        txHash = result;
        return result;
      })
      .catch((error) => {
        return false;
      });

    // TOKEN RELEASE FUNCTION
    await window.ethereum
      .request({
        method: "eth_sendTransaction",
        params: [
          {
            gas: "0x39100", // Metamask ignores gas - but without gas set it fails
            from: beyondiWalletAddress,
            to: crowdsaleContractAddress,
            data: await crowdsaleContractInstance.methods
              .releaseTokens(beyondiWalletAddress, purchaser)
              .encodeABI(),
          },
        ],
      })
      .then((result) => {
        txHash = result;
        return result;
      })
      .catch((error) => {
        return false;
      });
    return txHash;
  };
  private async verifyAndFixChain() {
    const chainId = await window.ethereum.request({
      method: "eth_chainId",
    });

    // Convert hex chainId to decimal for comparison
    const decimalChainId = parseInt(chainId, 16);
    console.log(decimalChainId);
    if (decimalChainId !== 80002) {
      try {
        // Try to switch to Mumbai network
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x13882" }], // This is 80002 in hex
        });
      } catch (error) {
        // If the chain hasn't been added to MetaMask, add it
        if (error.code === 4902) {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x13882",
                chainName: "Mumbai Testnet",
                nativeCurrency: {
                  name: "MATIC",
                  symbol: "MATIC",
                  decimals: 18,
                },
                rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
                blockExplorerUrls: ["https://mumbai.polygonscan.com"],
              },
            ],
          });
        }
      }
    }
  }
  private async verifyChainId() {
    const chainId = await window.ethereum.request({
      method: "eth_chainId",
    });
    console.log(chainId);
  }
  private async resetAccountState() {
    try {
      await window.ethereum.request({
        method: "wallet_requestPermissions",
        params: [
          {
            eth_accounts: {},
          },
        ],
      });
    } catch (error) {
      console.error("Failed to reset account state:", error);
    }
  }
  private async getCurrentNonce(address: string) {
    const nonce = await window.ethereum.request({
      method: "eth_getTransactionCount",
      params: [address, "latest"],
    });
    console.log(nonce);
    return nonce;
  }

  private async resetNonce(address: string) {
    try {
      // Get the current on-chain nonce
      const nonce = await this.getCurrentNonce(address);

      // Reset account state
      await window.ethereum.request({
        method: "wallet_requestPermissions",
        params: [
          {
            eth_accounts: {},
          },
        ],
      });

      return nonce;
    } catch (error) {
      console.error("Failed to reset nonce:", error);
      throw error;
    }
  }

  sendTransactionMetamask = async (currentUserAddress, contributionAmount) => {
    this.crowdsaleData.subscribe((data) => {
      this.crowdsale = data;
    });
    // this.verifyChainId();
    // this.resetAccountState();
    this.verifyAndFixChain();
    console.log(this.crowdsale);
    const beyondiWalletAddress = this.crowdsale.walletAddress;

    let contractAddressBYND = this.crowdsale.token.addressOnChain;

    const contractAddressStable = this.crowdsale.contributionTokenAddress;
    // const contractAddressStable = "0xA98C397ae0B638da0041Fa5Be903b40BF39ce63B";

    // const crowdsaleContractAddress = "0x9c080938f75b56DC215490721B04A91CA03d4C3c";

    const crowdsaleContractAddress = this.crowdsale.addressOnChain;

    // NOVI 0x7BE68BD6017b9d5390FeEc513D6E9B8aADeb3FD9

    let contractInstance = await listener.getContractInstance(
      contractAddressStable
    );

    let crowdsaleContractInstance = await listener.getCrowdsaleContractInstance(
      crowdsaleContractAddress
    );
    let txHash = "";
    // let contractAddressUsdc = "0xf0307093f23311FE6776a7742dB619EB3df62969";
    // let contractInstance = await listener.getContractInstance(contractAddressUsdc);
    let addressHolder = "0x33C387551E5Ca235B06c59093209ac32aFa9Ef07"; // This is Beyondis test wallet

    // let bnFormatedNumber = "0x" + await listener.getFormatedNumber(contributionAmount)

    let bnFormatedNumber = ethers.utils.parseEther(
      contributionAmount.toString()
    );
    // await contractInstance.methods.approve(crowdsaleContractAddress,bnFormatedNumber).call();
    console.log(bnFormatedNumber);

    console.log(currentUserAddress);
    console.log(contractAddressStable);
    // APPROVAL FUNCTION
    let nonce = await this.getCurrentNonce(currentUserAddress);
    console.log(nonce);
    let approvalTxHash;
    try {
      approvalTxHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: currentUserAddress,
            to: contractAddressStable,
            gas: "0x39100",
            nonce: nonce, // Add explicit nonce
            data: await contractInstance.methods
              .approve(crowdsaleContractAddress, bnFormatedNumber)
              .encodeABI(),
          },
        ],
      });
    } catch (error) {
      if (
        error.message.includes("nonce") ||
        error.message.includes("transaction")
      ) {
        // Reset nonce and retry
        nonce = await this.resetNonce(currentUserAddress);
        approvalTxHash = await window.ethereum.request({
          method: "eth_sendTransaction",
          params: [
            {
              from: currentUserAddress,
              to: contractAddressStable,
              gas: "0x39100",
              nonce: nonce,
              data: await contractInstance.methods
                .approve(crowdsaleContractAddress, bnFormatedNumber)
                .encodeABI(),
            },
          ],
        });
      } else {
        throw error;
      }
    }

    // Wait for approval confirmation
    await new Promise((resolve) => {
      const checkTx = setInterval(async () => {
        const receipt = await window.ethereum.request({
          method: "eth_getTransactionReceipt",
          params: [approvalTxHash],
        });
        if (receipt) {
          clearInterval(checkTx);
          resolve(receipt);
        }
      }, 1000);
    });

    // Increment nonce for next transaction
    nonce = `0x${(parseInt(nonce, 16) + 1).toString(16)}`;

    // CONTRIBUTION TRANSACTION
    let contributionTxHash;
    try {
      contributionTxHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: currentUserAddress,
            to: crowdsaleContractAddress,
            gas: "0x39100",
            nonce: nonce,
            data: await crowdsaleContractInstance.methods
              .contributeStableERC20(currentUserAddress, bnFormatedNumber, 0)
              .encodeABI(),
          },
        ],
      });
    } catch (error) {
      if (
        error.message.includes("nonce") ||
        error.message.includes("transaction")
      ) {
        // Reset nonce and retry
        nonce = await this.resetNonce(currentUserAddress);
        contributionTxHash = await window.ethereum.request({
          method: "eth_sendTransaction",
          params: [
            {
              from: currentUserAddress,
              to: crowdsaleContractAddress,
              gas: "0x39100",
              nonce: nonce,
              data: await crowdsaleContractInstance.methods
                .contributeStableERC20(currentUserAddress, bnFormatedNumber, 0)
                .encodeABI(),
            },
          ],
        });
      } else {
        throw error;
      }
    }

    return {
      txHash: contributionTxHash,
      crowdsaleID: this.crowdsale.id,
    };
    let txInfo = {
      txHash: txHash,
      crowdsaleID: this.crowdsale.id,
    };
    return txInfo;
  };
  getBalanceUsdc = async (currentUserAddress) => {
    let balance = 0;
    if (Array.isArray(currentUserAddress)) {
      currentUserAddress = currentUserAddress[0]; // Reason for this part of code is that walletConnect parses address in array instead of a string like metamask does.
    }
    // let contractAddressUsdc = "0xf0307093f23311FE6776a7742dB619EB3df62969";
    // let contractAddressUsdc = "0xc21223249CA28397B4B6541dfFaEcC539BfF0c59"
    let contractTestStable = "0x1281ae4b8666c6e80907B74c957F7a385bf1a3B9";
    let contractInstance = await listener.getContractInstance(
      contractTestStable
    );
    let contractMethodInstance = await contractInstance.methods
      .balanceOf(currentUserAddress)
      .call();
    return contractMethodInstance;
    // let contractInstance = await listener.getContractInstance(contractAddressUsdc);
    // let contractMethodInstance = await contractInstance.methods.balanceOf(currentUserAddress).call();
    // return contractMethodInstance;
  };
}
